import { Config } from "./types";

export const baseConfig: Partial<Config> = {
  PHASES: [
    { key: "Planning", value: "10" },
    { key: "Fieldwork", value: "20" },
    { key: "Completion", value: "30" },
  ],
  WORKPROGRAM_PHASES: [
    { key: "Planning", value: "10" },
    { key: "Response to Risk", value: "20" },
    { key: "Completion", value: "30" },
  ],
  SINGLE_ENGAGEMENT_FORMULA_CACHING_TIME: 1000 * 60, // 1 minute
  MULTI_ENGAGEMENT_FORMULA_CACHING_TIME: 1000 * 60, // 1 minute
  ENUM_PARAMETERS_CACHING_TIME: 1000 * 60 * 60 * 8, // 8 hours
  MAX_FORMULA_RECURSION_DEPTH: 30,
};

export function mergeConfig<T extends Partial<Config>>(overrides: T): Config {
  return { ...baseConfig, ...overrides } as Config;
}
